export default "__VITE_ASSET__DOPGKHuf__"